import { Route, Switch, Redirect } from 'react-router-dom';
import React from 'react';

const Introduction = React.lazy(() => import('../Introduction/Introduction'));
const BrandAssets = React.lazy(() => import('../BrandAssets/BrandAssets'));
const Colors = React.lazy(() => import('../Colors/Colors'));
const Elevation = React.lazy(() => import('../Elevation/Elevation'));
const Icons = React.lazy(() => import('../Icons/Icons'));
const Typography = React.lazy(() => import('../Typography/Typography'));
const Breadcrumbs = React.lazy(() => import('../Breadcrumbs/Breadcrumbs'));
const Buttons = React.lazy(() => import('../Buttons/Buttons'));
const Cards = React.lazy(() => import('../Cards/Cards'));
const Controls = React.lazy(() => import('../Controls/Controls'));
const Graphs = React.lazy(() => import('../Graphs/Graphs'));
const DropdownMenu = React.lazy(() => import('../DropdownMenu/DropdownMenu'));
const Inputs = React.lazy(() => import('../Inputs/Inputs'));
const Modals = React.lazy(() => import('../Modals/Modals'));
const ProfileDropdown = React.lazy(() => import('../ProfileDropdown/ProfileDropdown'));
const SidebarHeaders = React.lazy(() => import('../SidebarHeaders/SidebarHeaders'));
const Snackbar = React.lazy(() => import('../Snackbar/Snackbar'));
const SubCategoryList = React.lazy(() => import('../SubCategoryList/SubCategoryList'));
const Tables = React.lazy(() => import('../Tables/Tables'));

const TabsPage = React.lazy(() => import('../TabsPage/TabsPage'));
const Tooltips = React.lazy(() => import('../Tooltips/Tooltips'));

const layoutObj = [
  {
    route: '/introduction',
    component: Introduction,
  },
  {
    route: '/brand-assets',
    component: BrandAssets,
  },
  {
    route: '/colors',
    component: Colors,
  },
  {
    route: '/elevation',
    component: Elevation,
  },
  {
    route: '/icons',
    component: Icons,
  },
  {
    route: '/typography',
    component: Typography,
  },
  {
    route: '/breadcrumb',
    component: Breadcrumbs,
  },
  {
    route: '/buttons',
    component: Buttons,
  },
  {
    route: '/cards',
    component: Cards,
  },
  {
    route: '/controls',
    component: Controls,
  },
  {
    route: '/dropdown-menu',
    component: DropdownMenu,
  },
  {
    route: '/graphs',
    component: Graphs,
  },
  {
    route: '/inputs',
    component: Inputs,
  },
  {
    route: '/modals',
    component: Modals,
  },
  {
    route: '/profile-dropdown',
    component: ProfileDropdown,
  },
  {
    route: '/sidebar-headers',
    component: SidebarHeaders,
  },
  {
    route: '/snackbar',
    component: Snackbar,
  },
  {
    route: '/subcategories-list',
    component: SubCategoryList,
  },
  {
    route: '/tables',
    component: Tables,
  },
  {
    route: '/tabs',
    component: TabsPage,
  },
  {
    route: '/tooltips',
    component: Tooltips,
  },
];
export default layoutObj;
